import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addUserType, getUserTypeCategory, updateUserType } from "../../../services/userMasterUser";
import {
  validateFullName,
} from "../../../components/Regex";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function TypeCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    name: state?.name || "",
    category: state?.category || "",
    status: state?.status || true,
  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    name: "",
    category: "",
    status: "",
  });

  const [userTypeCategoryData, setUserTypeCategoryData] = useState();

  useEffect(() => {
     getUserTypeCategory()
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              const services = Res.map((item) => ({
                label: item,
                value: item,
              }));
              setUserTypeCategoryData(services);
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
  }, [])

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    
    if (!(input.name)) {
      newErrors.name = "Please Correct First Name";
      isValid = false;
    } else {
      newErrors.firstName = "";
    }
    
    
 
    if (input.status === "") {
      newErrors.status = "Please Choose Service";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          name: input.name,
          category: input.category,
          status: input.status,
        };
        updateUserType(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/type/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          name: input.name,
          category: input.category,
        };
        addUserType(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/type/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/type/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> User Type {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Category
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={userTypeCategoryData}
                        value={input.category}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            category: e.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.category}</div>
                    </div>
                  </div>
                  
                  {state?.id && <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
